var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,54c6.893,0,12.5-5.607,12.5-12.5v-26C48.5,8.607,42.893,3,36,3c-6.893,0-12.5,5.607-12.5,12.5v26 C23.5,48.393,29.107,54,36,54z M27.5,15.5c0-4.687,3.812-8.5,8.5-8.5c4.688,0,8.5,3.813,8.5,8.5v26c0,4.686-3.813,8.5-8.5,8.5 c-4.687,0-8.5-3.814-8.5-8.5V15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,24c0.552,0,1-0.447,1-1v-8.518c0-2.303,2.094-2.482,2.851-2.482h0.774c0.553,0,1-0.447,1-1s-0.447-1-1-1h-0.774 c-3.126,0-4.851,1.801-4.851,4.482V23C29.5,23.553,29.947,24,30.5,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,27v-1c0-0.553-0.448-1-1-1c-0.553,0-1,0.447-1,1v1c0,0.553,0.447,1,1,1C31.052,28,31.5,27.553,31.5,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5,37c-1.104,0-2,0.895-2,2v1.159C53.5,49.829,45.324,58,36.091,58h-0.212C26.421,58,18.5,49.663,18.5,40.158V39 c0-1.105-0.896-2-2-2s-2,0.895-2,2v1.159c0,11.032,8.324,20.464,19,21.7V65h-6.376c-1.104,0-2,0.895-2,2c0,1.104,0.896,2,2,2 h17.001c1.104,0,2-0.896,2-2c0-1.105-0.896-2-2-2H37.5v-3.055c10.973-0.755,20-10.234,20-21.787V39C57.5,37.895,56.604,37,55.5,37z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSon);
export default __webpack_public_path__ + "static/media/son.b3fe59933021a6080d23a50adc1c06f1.svg";
export { ForwardRef as ReactComponent };